import _ from 'lodash';
import webUtils from '@/tools/web-utils'

export default function install(Vue) {
  Vue.prototype.$_msgbox = function(msg) {
    const h = this.$createElement;
    return this.$msgbox({
      title: '消息',
      message: h('span', { style: { 'font-size': '15px' } }, msg),
      showClose: false,
      closeOnClickModal: false,
      showCancelButton: false,
      lockScroll: false,
      confirmButtonText: '确定',
      type: 'warning'
    });
  };
  Vue.prototype.$rejectAjaxError = function(obj) {
    obj = obj || {};
    let defErrorHandler = {
      error: function(error) {
        if (error.code == 'ECONNABORTED' && error.message && _.includes(error.message, 'timeout')) {
          throw new TimeOutError();
        }
        let message = _.at(error, 'response.data.message')[0];
        if (!message) {
          throw new Error('errorMsg is null');
        }
        this.$notify.error({ title: '错误', message });
      },
      statusCode: {
        400: function(error) {
          let message = _.at(error, 'response.data.message')[0];
          if (!message) {
            throw new Error('errorMsg is null');
          }
          this.$notify.error({ title: '参数错误', message });
        },
        401: function(error) {
          webUtils.redirect2QxLogin();
        }
      },
      qxCode: {},
      timeout: function () {
        this.$notify.error({ title: '错误', message: '请求超时' });
      }
    };
    return getErrorHandler.call(this, _.merge(defErrorHandler, obj));
  };
}

function getErrorHandler(obj) {
  return err => {
    let statusCodeObj = _.at(obj, 'statusCode')[0];
    let qxCodeObj = _.at(obj, 'qxCode')[0];
    let status = _.at(err, 'response.status')[0];
    let qxCode = _.at(err, 'response.data.code')[0];
    let statusCallback = _.at(statusCodeObj, status)[0];
    let qxErrCallback = _.at(qxCodeObj, qxCode)[0];
    let errorCallback = _.at(obj, 'error')[0];
    let timeoutCallback = _.at(obj, 'timeout')[0];
    let callback = qxErrCallback || statusCallback || errorCallback;
    try {
      callback.call(this, err);
    } catch (e) {
      if (e instanceof TimeOutError) {
        timeoutCallback.call(this);
      } else {
        this.$notify.error({ title: '错误', message: '未知错误' });
      }
    }
  };
}

function TimeOutError() {}
